var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.755,
    height: 17.724,
    viewBox: "0 0 17.755 17.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Clipping_Path_",
    "data-name": "<Compound Clipping Path>",
    d: "M5287.07,2839.419a2.133,2.133,0,1,1-2.132-2.133A2.134,2.134,0,0,1,5287.07,2839.419Zm-3.973,15.592h3.68v-11.839h-3.68Zm13.048-12.134a3.866,3.866,0,0,0-3.482,1.912h-.049v-1.618h-3.529v11.839h3.676v-5.857c0-1.544.294-3.039,2.208-3.039,1.887,0,1.912,1.766,1.912,3.139v5.757h3.677v-6.494C5300.559,2845.329,5299.871,2842.876,5296.145,2842.876Z",
    transform: "translate(-5282.804 -2837.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.907,
    cy: 0.093,
    r: 1.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393939"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48205",
    "data-name": "Group 48205",
    clipPath: "url(#clip-path-linkedin)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACK",
    transform: "translate(-11.797 -11.812)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACK-2",
    "data-name": "BACK"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15197",
    "data-name": "Rectangle 15197",
    width: 41.349,
    height: 41.349,
    rx: 20.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15198",
    "data-name": "Rectangle 15198",
    width: 41.349,
    height: 41.349,
    rx: 20.675,
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "COLOR"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15199",
    "data-name": "Rectangle 15199",
    width: 41.349,
    height: 41.349,
    rx: 20.675,
    fill: "#0076b2",
    style: {
      mixBlendMode: "color",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15200",
    "data-name": "Rectangle 15200",
    width: 41.349,
    height: 41.349,
    rx: 20.675,
    fill: "#0076b2",
    opacity: 0.6,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.acdd7a1636c6db3d8ebf273128c38a0f.svg";
export { ForwardRef as ReactComponent };